/**
 * Converts snake_case to camelCase
 * @param {string} str
 * @returns {string}
 */
function toCamelCase(str) {
  return str.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
}

/**
 * Dynamically transform and filter fields from data records.
 * Supports nested value extraction, field mapping, and camelCase keys.
 * 
 * @param {Array<Object>} data - Raw data array (e.g., tenants)
 * @param {Array<string>} keys - List of keys to retain/transform
 * @returns {Array<Object>} - Transformed result with camelCase keys
 */
function dynamicFieldTransformer(data, keys) {
  const formatDate = (isoString) => {
    if (!isoString) return null;
    const date = new Date(isoString);
    return `${String(date.getDate()).padStart(2, '0')}/` +
           `${String(date.getMonth() + 1).padStart(2, '0')}/` +
           date.getFullYear();
  };

  const statusMap = {
    active: '✅ Active',
    inactive: '🚫 Inactive',
    pending: '⏳ Pending Approval',
  };

  return data.map(item => {
    const transformed = {};

    keys.forEach(originalKey => {
      const camelKey = toCamelCase(originalKey);
      const value = item[originalKey];

      // Apply custom transformations
      switch (originalKey) {
        case '_id':
              transformed[originalKey] = value || '-';
          break;
        case 'tenant_type':
        case 'tenant_industryType':
          transformed[camelKey] = value?.value || '-';
          break;

        case 'tenant_regDetails':
          transformed[camelKey] = Array.isArray(value)
            ? value.map(v => `${v.name} (${v.doc_type})`).join(', ')
            : '-';
          break;

        case 'tenant_systemCapabilities':
          transformed[camelKey] = Array.isArray(value)
            ? value.map(v => v.value).join(', ')
            : '-';
          break;

        case 'status':
          transformed[camelKey] = statusMap[value] || value;
          break;

        case 'createdAt':
        case 'updatedAt':
          transformed[camelKey] = formatDate(value);
          break;

        case 'address':
          transformed[camelKey] = value
            ? `${value.tenant_address1 || ''}, ${value.tenant_city || ''}, ${value.tenant_state || ''}`
            : '-';
          break;

        case 'contact':
          transformed[camelKey] = Array.isArray(value)
            ? value.map(c => `${c.tenant_firstName} ${c.tenant_lastName} (${c.tenant_email})`).join(', ')
            : '-';
          break;

        default:
          transformed[camelKey] = value ?? '-';
      }
    });

    return transformed;
  });
}

module.exports = dynamicFieldTransformer;
